export default __webpack_public_path__ + "static/media/7.e0fd0bb2.jpg";